import React from 'react';
import './index.scss';

const NewsIndicatorOverlay = () => <span className={"a-news-indicator-overlay"}/>;

export default NewsIndicatorOverlay;

